import React from "react";
const OpenEye: React.FC<{ className: string; onClick: () => void }> = ({
  className,
  onClick,
}) => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g id="Open=True">
        <path
          id="Vector"
          d="M6.52177 7.84192L6.5227 7.84118C7.87642 6.76205 9.71146 5.87305 11.9955 5.87305C14.2796 5.87305 16.1146 6.76205 17.4683 7.84118L17.4692 7.84192C18.7952 8.896 19.6836 10.1522 20.1066 10.998C19.6838 11.8432 18.7955 13.0974 17.4685 14.1548L17.4683 14.1549C16.1146 15.234 14.2796 16.123 11.9955 16.123C9.71146 16.123 7.87642 15.234 6.5227 14.1549L6.52177 14.1542C5.19453 13.0991 4.30651 11.8421 3.88736 10.998C4.30651 10.154 5.19453 8.897 6.52177 7.84192Z"
          stroke="#123333"
          strokeWidth="1.75"
        />
        <circle
          id="Ellipse 3232"
          cx="11.9971"
          cy="10.998"
          r="3"
          fill="#123333"
        />
      </g>
    </svg>
  );
};

export default OpenEye;
